import React from 'react';
import Link from 'next/link';
import Slider, { CustomArrowProps } from 'react-slick';

import { abbreviateState, formatUnitNumber } from '../../../lib/helpers';
import NumberElement from '../../../components/utility/NumberElement/index';
import { formatBathrooms, formatUrlAddress } from '../../../lib/helpers';
import { BackwardsLeftIcon, ForwardRightIcon } from '../Icons';

import styles from '../../../styles/sass/components/ListingPreview.module.scss';

interface Props {
  listing: any;
}

const LeftIcon = ({
  currentSlide,
  slideCount,
  ...props
} = CustomArrowProps) => {
  return (
    <div
      {...props}
      onClick={e => {
        e.preventDefault();
        props.onClick();
      }}
    >
      <BackwardsLeftIcon />
    </div>
  );
};

const RightIcon = ({
  currentSlide,
  slideCount,
  ...props
} = CustomArrowProps) => {
  return (
    <div
      {...props}
      onClick={e => {
        e.preventDefault();
        props.onClick();
      }}
    >
      <ForwardRightIcon />
    </div>
  );
};

const settings = {
  infinite: true,
  initialSlide: 0,
  lazyLoad: 'ondemand',
  nextArrow: <RightIcon />,
  prevArrow: <LeftIcon />,
  slidesToScroll: 1,
  slidesToShow: 1,
  swipeToSlide: true,
};

export default class SimpleListingPreview extends React.Component<Props> {
  listingList = () => {
    return this.props.listing.photoMediumList.map(
      (photo: any, index: number) => (
        <div className="slick-slide" key={index}>
          <img
            src={photo}
            className={styles.slickSlideImage}
            alt={`listing-photo--${index}`}
            style={{
              height: 300,
              width: 400,
            }}
          />
        </div>
      ),
    );
  };

  render() {
    const { listing } = this.props;
    let price = listing.listPrice;
    if (listing.salePrice) {
      price = listing.salePrice;
    }

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          width: '100%',
        }}
      >
        <Link
          as={`/listing/r/${listing.id}/${formatUrlAddress(listing)}`}
          href={`/listing/r/listingId=${listing.id}`}
          prefetch={false}
        >
          <a target="_blank">
            <div
              className={`${styles.simpleSliderWrapper} simple-slider-wrapper`}
            >
              <div className={styles.slideOverlay}>&nbsp;</div>
              <Slider {...settings}>{this.listingList()}</Slider>
            </div>
          </a>
        </Link>
        <div
          style={{
            alignItems: 'flex-start',
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            justifyContent: 'center',
            paddingLeft: '5%',
            paddingRight: '5%',
            paddingTop: '2%',
          }}
        >
          <span
            style={{
              color: '#323232',
              fontSize: 14,
              fontWeight: 'bold',
            }}
          >
            {listing.streetNo} {listing.streetName}
            {listing.unitNo ? ` ${formatUnitNumber(listing.unitNo)}` : ''}
            {price && (
              <span
                style={{
                  color: '#195A50',
                  fontWeight: 'bold',
                  marginLeft: 15,
                }}
              >
                <NumberElement decimalScale={0} prefix="$" val={price} />
              </span>
            )}
          </span>
          <span style={{ color: '#323232', fontSize: 14 }}>
            {listing.town}, {abbreviateState(listing.state)} {listing.zipCode}
          </span>
          <p>
            {listing.propType === 'Multi-Family' && (
              <span style={{ marginRight: 3 }}>{listing.noUnits} units </span>
            )}
            <span style={{ marginRight: 3 }}>{listing.noBedrooms}br </span>
            <span style={{ marginRight: 3 }}>
              {formatBathrooms(listing)}ba{' '}
            </span>
            <span style={{ marginRight: 3 }}>
              {listing.squareFeet ? (
                <NumberElement val={listing.squareFeet} decimalScale={0} />
              ) : (
                '--'
              )}
              sf{' '}
            </span>
            <span style={{ marginRight: 3 }}>
              <NumberElement
                val={listing.listPricePerSqft}
                prefix="$"
                decimalScale={2}
              />
              /sf
            </span>
          </p>
        </div>
      </div>
    );
  }
}
